"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.new-section.prompt': '向我介绍一个新部分',
};
